module.exports = __webpack_public_path__ + "static/bergolla-eaa116c7eca6ddcfc88c16df4c100113.png";